import LoadingButton from "../../../../../../components/Loading/LoadingButton";
import usePDFDownload from "../../../../../../hooks/usePDFDownload";

export default function DownloadContractTerminationButton() {
  const { mutate, isPending } = usePDFDownload({
    method: "GET",
    url: "/agent/v1/print-terminate-contract",
  });

  return (
    <LoadingButton
      className="btn-success-style"
      center
      isLoading={isPending}
      title="پرینت"
      onClick={() => mutate()}
    />
  );
}
